// removed by extract-text-webpack-plugin
module.exports = {"Products":"src-components-Products----Products-module---Products---2XhEZ","container":"src-components-Products----Products-module---container---1R6aK"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Products/Products.module.css
// module id = 387
// module chunks = 35783957827783